import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { RootState, actions } from '../store';
import { IonPage, IonItem, IonCardContent, IonCard, IonCardSubtitle,
  IonBackButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar,
} from '@ionic/react';
import { Campground } from '../store/campgrounds/types';
// import Map from '../components/CampMap';

const MarkerClusterer = require('node-js-marker-clusterer');

type Props = RouteComponentProps<{ id: string, tab: string }> & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps> & {
  goBack: () => void
};

type State = {
  campgrounds: any;
  list: any,
};

class CampgroundsDetails extends React.Component<Props, State> {
  mapEle: any;
  map?: any;
  markers: any[];
  defaultState: State = {
    campgrounds: [],
    list: {},
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      ...this.defaultState
    };
    this.mapEle = React.createRef();
    this.markers = [];
  }
  componentWillMount = async () => {
    const {
      match,
    } = this.props;
    await this.props.getCampgrounds(match.params.id);
  }

  componentDidMount() {
    const { parkMap, loadedCampgrounds, match } = this.props;
    const lat = parkMap[match.params.id] && parkMap[match.params.id].lat;
    const lng = parkMap[match.params.id] && parkMap[match.params.id].lng;
    if (!lat || !lng) {
      return;
    }
    this.map = new google.maps.Map(this.mapEle.current, {
      center: { lat, lng },
      zoom: 7
    });
    const list = {};
    const campgrounds = loadedCampgrounds[match.params.id];
    campgrounds.forEach((item: any, index: number) => {
      const {  latLong, name } = item;
      list[index] = false;
      if (!latLong) {
        return;
      }
      let latLong2 = latLong.substring(1, latLong.length - 1).split(',');
      const lat = Number(latLong2[0].split(':')[1]);
      const lng = Number(latLong2[1].split(':')[1]);
      let infoWindow = new google.maps.InfoWindow({
        content: `${name}`
      });
      let marker = new google.maps.Marker({
        position: {
          lat,
          lng,
        },
        map: this.map,
        title: JSON.stringify(item.name),
        icon: '/assets/img/tent.png'
      });

      marker.addListener('click', () => {
        infoWindow.open(this.map, marker);
        // this.setShowPopover(true);
        // this.setState({
        //   ...this.state,
        //   data: marker.getTitle() || '{}',
        // });
      });
      this.markers.push(marker);
    });
    this.setState({
      ...this.state,
      list,
    });
    var markerCluster = new MarkerClusterer( // eslint-disable-line
      this.map,
      this.markers,
      { imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m' },
    );
    // zoom and center the map around the markers
    if (this.map && this.markers.length) {
      const bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < this.markers.length; i++) {
        bounds.extend(this.markers[i].getPosition());
      }
      // this.map.fitBounds(bounds);
      this.map.getCenter();
    }
    try {
      let adsbygoogle;
      // @ts-ignore
      (adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }

  handleAccordion(index: number) {
    const list = {};
    Object.keys(this.state.list).forEach((item) => {
      list[item] = false;
    });
    this.setState({
      ...this.state,
      list: {
        ...list,
        [index]: !this.state.list[index],
      },
    });
  }

  render() {
    const { match, loadedCampgrounds, parkMap } = this.props;
    const parkCode = match.params.id;
    const parkName = parkMap[parkCode] && parkMap[parkCode].name;
    const campgrounds = loadedCampgrounds[parkCode];

    const UNKNOWN = '???';
    return (
      <IonPage className="campground-details">
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref={match.url.replace('/campgrounds', '')} />
            </IonButtons>
            <IonTitle>{parkName} Campgrounds</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonCard>
          { campgrounds && campgrounds.map((camp: Campground, index: number) => {
            return (
              <IonItem key={`camp-${index}`} onClick={() => { this.handleAccordion(index) } }>
                <IonCardContent key={'camp'+index} className="width100" >
                  <IonCardSubtitle className="width100" >
                    {camp.name}({camp.campsites.totalSites})
                    <FontAwesomeIcon className="floatRight" icon={this.state.list[index] ? faAngleUp : faAngleDown} />
                  </IonCardSubtitle>
                  <div></div>
                  <div className={this.state.list[index] ? 'noLeftPadding grayBg slider' : 'slider closed' }>
                    <IonCardContent>
                      <div>{camp.description}</div>
                    </IonCardContent>
                    <IonCardContent>
                      <div>Passport Stamp Location: {camp.isPassportStampLocation === "0" ? 'Yes' : 'No' }</div>
                    </IonCardContent>
                    <IonCardContent>
                      <div>Location: {camp.latLong ? 'See map below' : 'Not Available' }</div>
                    </IonCardContent>
                    <IonCardContent>
                      <div>Campsites</div>
                      <ul>
                        <li>Total Sites: {camp.campsites.totalSites}</li>
                        <li>Horse: {camp.campsites.horse}</li>
                        <li>Tent Only: {camp.campsites.tentOnly}</li>
                        <li>RV Only: {camp.campsites.rvOnly}</li>
                        <li>Walk Boat To: {camp.campsites.walkBoatTo}</li>
                        <li>Electrical Hook ups: {camp.campsites.electricalHookups}</li>
                        <li>Group: {camp.campsites.group}</li>
                        <li>Other: {camp.campsites.other}</li>
                      </ul>
                    </IonCardContent>
                    <IonCardContent>
                      <div>Accessibility:
                        <ul>
                          <li>Classifications: {camp.accessibility.classifications.join(',') || UNKNOWN}</li>
                          <li>Wheelchair Access: {camp.accessibility.wheelchairaccess || UNKNOWN}</li>
                          <li>RV Allowed: { camp.accessibility.rvallowed ? (Number(camp.accessibility.rvallowed) === 0 ? 'NO' : 'YES') : UNKNOWN }</li>
                          <li>RV Info: {camp.accessibility.rvinfo || UNKNOWN}</li>
                          <li>Trailer Allowed: { camp.accessibility.trailerallowed ? (Number(camp.accessibility.trailerallowed) === 0 ? 'NO' : 'YES') : UNKNOWN }</li>
                          {/* <li>RV Max Length: {camp.accessibility.rvmaxlength}</li> */}
                          {/* <li>Trailer Max Length: {camp.accessibility.rvmaxlength}</li> */}
                          <li>Internet: {camp.accessibility.internetconnectivity || UNKNOWN}</li>
                          <li>Fire Stove: {camp.accessibility.firestovepolicy || UNKNOWN}</li>
                          <li>ADA Info: {camp.accessibility.adainfo || UNKNOWN}</li>
                          <li>Access Roads: {(camp.accessibility.accessroads ? camp.accessibility.accessroads.join(',') : camp.accessibility.accessRoads.join(',')) || UNKNOWN}</li>
                          <li>Additional Info: {camp.accessibility.additionalinfo || UNKNOWN}</li>
                        </ul>
                      </div>
                    </IonCardContent>
                    <IonCardContent>
                      <div>Regulation</div>
                      <div>{camp.regulationsOverview} <a href={camp.regulationsurl}>{camp.regulationsurl}</a></div>
                      <div>{camp.regulationsOverview.length > 0 && camp.regulationsurl.length > 0 ? '' :  'Not Available'}</div>
                    </IonCardContent>
                    <IonCardContent>
                      <div>Weather</div>
                      <div>{camp.weatherOverview ? camp.weatherOverview : 'Not Available'}</div>
                    </IonCardContent>
                    <IonCardContent>
                      <div>Directions</div>
                      <div>{camp.directionsOverview }<a href={camp.directionsUrl}>{camp.directionsUrl}</a></div>
                      <div>{camp.directionsOverview.length > 0 && camp.directionsOverview.length > 0 ? '' :  'Not Available'}</div>
                    </IonCardContent>
                    <IonCardContent>
                      <div>Amenities:
                        <ul>
                          <li>Trash Recycling: {camp.amenities.trashRecyclingCollection || UNKNOWN}</li>
                          <li>Toilets: {camp.amenities.toilets.join(',') || UNKNOWN}</li>
                          <li>Showers: {camp.amenities.showers.join(',') || UNKNOWN}</li>
                          <li>Laundry: {camp.amenities.laundry || UNKNOWN}</li>
                          <li>Internet: {camp.amenities.internetConnectivity || UNKNOWN}</li>
                          <li>Cell Reception: {camp.amenities.cellPhoneReception || UNKNOWN}</li>
                          <li>Dump Station: {camp.amenities.dumpStation || UNKNOWN}</li>
                          <li>Campstore: {camp.amenities.campStore || UNKNOWN}</li>
                          <li>Staff/Volunteer: {camp.amenities.staffOrVolunteerHostOnsite || UNKNOWN}</li>
                          <li>Potable Water: {camp.amenities.potableWater.join(',') || UNKNOWN}</li>
                          <li>Ice for Sale: {camp.amenities.iceAvailableForSale || UNKNOWN}</li>
                          <li>Firewood for Sale: {camp.amenities.firewoodForSale || UNKNOWN}</li>
                          <li>Food Storage Lockers: {camp.amenities.foodStorageLockers || UNKNOWN}</li>
                          <li>Amphitheater: {camp.amenities.ampitheater || UNKNOWN}</li>
                        </ul>
                      </div>
                    </IonCardContent>
                  </div>
                </IonCardContent>
              </IonItem>
            )
          })}
            <IonCardContent>
              <div style={{position: 'relative'}}>
                <div ref={this.mapEle} style={{height: '400px', width: '100%'}} id="location-map"></div>
              </div>
            </IonCardContent>
            <ins className="adsbygoogle"
            style={{display:'block'}}
            data-ad-client="ca-pub-2796376641761374"
            data-ad-slot="1578893839"
            data-ad-format="auto"
            data-full-width-responsive="true"></ins>
          </IonCard>
        </IonContent>
        {/* <IonContent class="map-page">
          <Map campgrounds={campgrounds} mapCenter={this.props.mapCenter}/>
        </IonContent> */}
      </IonPage>
    );
  }
  
}

const mapDispatchToProps = {
  getCampgrounds: (parkCode: string) => actions.campgrounds.getCampgrounds(parkCode),
}

const mapStateToProps = (state: RootState) => ({
  parkMap: state.places.parkMap,
  loadedCampgrounds: state.campgrounds.loadedCampgrounds,
  parkName: state.campgrounds.parkName,
  parkCode: state.campgrounds.parkCode,
  latLong: state.campgrounds.latLong,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CampgroundsDetails)
